import Mozart1 from '../Mozart/Mozart.webp'
import Mozart2 from '../Mozart/Mozart (2).webp'
import Mozart3 from '../Mozart/Mozart (3).webp'
import Mozart4 from '../Mozart/Mozart (4).webp'
import Mozart5 from '../Mozart/Mozart (5).webp'
import Mozart6 from '../Mozart/Mozart (6).webp'
import Mozart7 from '../Mozart/Mozart (7).webp'
import Mozart8 from '../Mozart/Mozart (8).webp'
import Mozart9 from '../Mozart/Mozart (9).webp'
import Mozart10 from '../Mozart/Mozart (10).webp'
import Mozart11 from '../Mozart/Mozart (11).webp'
import Mozart12 from '../Mozart/Mozart (12).webp'
import Mozart13 from '../Mozart/Mozart (13).webp'
import Mozart14 from '../Mozart/Mozart (14).webp'
import Mozart15 from '../Mozart/Mozart (15).webp'


const Mozartimages =[
Mozart1,Mozart2,Mozart3,Mozart4,Mozart5,Mozart6,Mozart7,Mozart8,Mozart9,Mozart10,Mozart11,Mozart12,Mozart13,Mozart14,Mozart15
]

export default Mozartimages;